import React, { useState, useEffect } from 'react';
import { Form } from '@rocketseat/unform';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import produce from 'immer';
import { MdSearch, MdFilterList } from 'react-icons/md';

import {
  Modal,
  Text,
  Button,
  WrapperFlex,
  Title,
  Breadcrumbs,
  SearchBox,
} from '@unimed-fesp/components';

import { AiOutlinePlus } from 'react-icons/ai';
import { Creators as UsuarioActions } from '../../store/ducks/usuario';

import 'react-toastify/dist/ReactToastify.css';

import { isPartialEmail } from '../../utils/validation';

import theme from '../../styles/theme';
import history from '../../services/history';
import { Container } from './styles';

import { TipoStatusEnum, TipoPerfilUsuarioEnum } from '../../enums';

import FadeIn from '../../components/atoms/FadeIn';

import FilterExtendsUsuarios from '../../components/organisms/FilterExtendsUsuarios';
import TabTableUsuarios from '../../components/organisms/TabTableUsuarios';
import ModalNovoUsuario from '../../components/organisms/ModalNovoUsuario';

function UsuarioGestao() {
  const dispatch = useDispatch();

  const { success } = useSelector((state) => state.modalidade);
  const { patchLiberarAcesso, patchStatusUsuario, getConsultaUsuarios } =
    useSelector((state) => state.usuario);

  const [usuarioAction, setUsuarioAction] = useState({
    usuarios: [],
    tipoAcao: '',
  });
  const [openModalNovoUsuario, setModalNovoUsuario] = useState(false);
  const [openModalError, setModalError] = useState({
    error: false,
    acaoUsuario: '',
    message: '',
  });
  const [openModalAcaoUsuario, setOpenModalAcaoUsuario] = useState({
    success: false,
    acaoUsuario: '',
    message: '',
  });
  const [openModalCancelAction, setOpenModalCancelAction] = useState({
    warning: false,
    message: '',
  });
  const [openFilterExtends, setOpenFilterExtends] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [cancelFilterExtendsOpen, setCancelFilterExtendsOpen] = useState(false);

  const filterExtendsParams = {
    nome: null,
    email: null,
    tipoPerfil: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataLiberacaoDe: null,
    dataLiberacaoAte: null,
    dataInativacaoDe: null,
    dataInativacaoAte: null,
  };

  const paginationTabParams = {
    tipoStatus: TipoStatusEnum.returnNameForTab.Todas,
    pageNumber: 1,
    pageSize: 10,
    nextPage: null,
    previousPage: null,
  };

  const [filterParams, setFilterParams] = useState(filterExtendsParams);
  const [paginationParams, setPaginationParams] = useState(paginationTabParams);

  function handleModalCancelAction() {
    setOpenModalCancelAction({
      warning: !openModalCancelAction.warning,
    });
  }
  const handleCancelarCadastro = () => {
    history.push(`/novo/gestao`);
  };

  function handleModalNovoUsuario() {
    setModalNovoUsuario(!openModalNovoUsuario);
  }

  function handleData(data) {
    const newFilterParams = produce(filterParams, (draft) => {
      draft.nome =
        !inputValue || isPartialEmail(inputValue) ? null : inputValue;
      draft.email = isPartialEmail(inputValue) ? inputValue : null;
      draft.tipoPerfil =
        data.perfil === 'Selecione o perfil'
          ? null
          : TipoPerfilUsuarioEnum.returnNameForNameFormatted[data.perfil];
      draft.dataCriacaoDe = data.dataCriacaoDe
        ? format(data.dataCriacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.dataCriacaoAte = data.dataCriacaoAte
        ? format(data.dataCriacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;
      draft.dataLiberacaoDe = data.dataLiberacaoDe
        ? format(data.dataLiberacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.dataLiberacaoAte = data.dataLiberacaoAte
        ? format(data.dataLiberacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;
      draft.dataInativacaoDe = data.dataInativacaoDe
        ? format(data.dataInativacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.dataInativacaoAte = data.dataInativacaoAte
        ? format(data.dataInativacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;

      return draft;
    });

    const newPaginationParams = produce(paginationParams, (draft) => {
      draft.pageNumber = 1;
      draft.pageSize = 10;
    });

    const params = {
      ...newFilterParams,
      ...newPaginationParams,
    };

    setFilterParams(newFilterParams);
    setPaginationParams(newPaginationParams);
    return params;
  }

  function handleSubmit(data) {
    const params = handleData(data);

    dispatch(
      UsuarioActions.getConsultaUsuariosRequest(
        params,
        TipoStatusEnum.returnNameForTab
      )
    );
    setCancelFilterExtendsOpen(false);
  }

  function handleFilterExtends() {
    setOpenFilterExtends(!openFilterExtends);
  }

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function handleInputKeyDown(e) {
    if (e.keyCode === 13) {
      // 'enter' was pressed
      setCancelFilterExtendsOpen(true);
    }
  }

  function handlePageChangeKeyDown(e) {
    if (e.keyCode === 13) {
      const params = {
        ...filterParams,
        ...paginationParams,
      };

      if (paginationParams.pageNumber !== '')
        dispatch(UsuarioActions.getConsultaUsuariosPorStatusRequest(params));
    }
  }

  function handleActiveTab(status) {
    const newPaginationTab = produce(paginationParams, (draft) => {
      draft.tipoStatus = status;

      return draft;
    });

    setPaginationParams(newPaginationTab);
  }
  function handleSelectedPageSize(e) {
    const newPageSize = produce(paginationParams, (draft) => {
      draft.pageSize = e.target.dataset.text;
      draft.pageNumber = 1;

      return draft;
    });
    const params = {
      ...filterParams,
      ...newPageSize,
    };

    dispatch(UsuarioActions.getConsultaUsuariosPorStatusRequest(params));

    setPaginationParams(newPageSize);
  }

  function handlePageChange(e) {
    const newPageAtual = produce(paginationParams, (draft) => {
      draft.pageNumber = e.target.value;

      return draft;
    });

    if (
      newPageAtual.totalPages >= newPageAtual.pageNumber &&
      newPageAtual.pageNumber !== '0'
    )
      setPaginationParams(newPageAtual);
  }

  function handleNextPage() {
    const newPageAtual = produce(paginationParams, (draft) => {
      if (draft.totalPages !== draft.pageNumber) draft.pageNumber += 1;

      return draft;
    });

    const params = {
      ...filterParams,
      ...newPageAtual,
    };
    if (paginationParams.totalPages !== paginationParams.pageNumber)
      dispatch(UsuarioActions.getConsultaUsuariosPorStatusRequest(params));

    setPaginationParams(newPageAtual);
  }

  function handleChangeTab(nameTab) {
    const nameTabCapitalize = `${nameTab
      .charAt(0)
      .toUpperCase()}${nameTab.slice(1)}`;
    const { pageNumber, pageSize } =
      getConsultaUsuarios.response[nameTabCapitalize];
    setPaginationParams((oldParams) => ({
      ...oldParams,
      pageNumber,
      pageSize,
    }));
  }

  function handleChangePage(paramsPag, tipoStatus) {
    const params = {
      ...filterParams,
      ...paramsPag,
      tipoStatus,
    };

    dispatch(UsuarioActions.getConsultaUsuariosPorStatusRequest(params));
  }

  function setUsuarioActionToDispatch(action, params) {
    const actions = {
      PendenteLiberacao: UsuarioActions.patchLiberarAcessoRequest(params),
      Ativo: UsuarioActions.patchStatusRequest(
        params,
        TipoStatusEnum.returnNameForName.Inativo
      ),
      Inativo: UsuarioActions.patchStatusRequest(
        params,
        TipoStatusEnum.returnNameForName.Ativo
      ),
    };

    return actions[action];
  }

  function handleAcaoUsuarioById() {
    const params = [
      {
        idUsuario: usuarioAction.usuarios,
      },
    ];
    const actionUsuario = setUsuarioActionToDispatch(
      usuarioAction.tipoAcao,
      params
    );

    dispatch(actionUsuario);
  }

  function handleAcaoUsuarios() {
    const params = usuarioAction.usuarios.map((u) => {
      return { idUsuario: u.user.idUsuario };
    });

    const actionUsuario = setUsuarioActionToDispatch(
      usuarioAction.tipoAcao,
      params
    );

    dispatch(actionUsuario);
  }

  function setAcaoUsuario() {
    setOpenModalCancelAction({
      warning: !openModalCancelAction.warning,
    });

    return Array.isArray(usuarioAction.usuarios)
      ? handleAcaoUsuarios()
      : handleAcaoUsuarioById();
  }

  function handleConfirmAction(usuarios, tipoAcao) {
    setUsuarioAction({ usuarios, tipoAcao });

    const messagesPerAction = {
      Ativo: 'Deseja realmente inativar este usuário?',
      Inativo: 'Deseja realmente ativar este usuário?',
      PendenteLiberacao: 'Deseja realmente liberar acesso a este usuário?',
    };

    setOpenModalCancelAction({
      warning: !openModalCancelAction.warning,
      message: messagesPerAction[tipoAcao],
    });
  }

  function getUsuariosGestao() {
    const params = {
      ...paginationParams,
      pageNumber: 1,
      pageSize: 10,
    };

    dispatch(
      UsuarioActions.getConsultaUsuariosRequest(
        params,
        TipoStatusEnum.returnNameForTab
      )
    );
  }

  function handleModalUsuarioAcao() {
    setOpenModalAcaoUsuario({
      success: false,
      message: 'solicitação de liberação enviada.',
    });

    if (patchLiberarAcesso.success)
      dispatch(UsuarioActions.patchLiberarAcessoRenew());
    if (patchStatusUsuario.success) dispatch(UsuarioActions.patchStatusRenew());

    getUsuariosGestao();
  }
  function handleModalError() {
    setModalError({
      error: false,
      message: 'solicitação de liberação enviada.',
    });
    if (patchLiberarAcesso.success)
      dispatch(UsuarioActions.patchLiberarAcessoRenew());
    if (patchStatusUsuario.success) dispatch(UsuarioActions.patchStatusRenew());
  }

  useEffect(() => {
    if (patchLiberarAcesso.success)
      setOpenModalAcaoUsuario({
        success: !openModalAcaoUsuario.success,
        message: 'solicitação de liberação enviada.',
      });
  }, [patchLiberarAcesso.success]);

  useEffect(() => {
    if (patchLiberarAcesso.isError)
      setModalError({
        error: !openModalError.error,
        message: 'Erro ao liberar acesso!',
      });
  }, [patchLiberarAcesso.isError]);

  useEffect(() => {
    if (patchStatusUsuario.success)
      setOpenModalAcaoUsuario({
        success: !openModalAcaoUsuario.success,
        message: 'solicitação de alteração de status enviada.',
      });
  }, [patchStatusUsuario.success]);

  useEffect(() => {
    if (patchStatusUsuario.isError)
      setModalError({
        error: !openModalError.error,
        message: 'Erro ao alterar o status!',
      });
  }, [patchStatusUsuario.isError]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="gestão de usuários"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
            <WrapperFlex
              percentageWidth={30}
              justifyEnd
              alignCenter
              marginSides={10}
              flexWrap
            >
              <Button
                tipo="primary"
                paddingTop={10}
                paddingRight={10}
                paddingBottom={10}
                paddingLeft={10}
                justifySpaceBetween
                alignCenter
                width={150}
                font="16px unimed_slabregular"
                onClick={handleModalNovoUsuario}
              >
                <AiOutlinePlus color="#FFFF" />
                novo usuário
              </Button>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'gestão de usuários',
                onNavigate: () => history.push('/novo/gestao'),
              },
            ]}
          />
        </WrapperFlex>
        <Form onSubmit={handleSubmit}>
          <WrapperFlex justifyStart alignStart row>
            <SearchBox
              onClick={handleFilterExtends}
              isPressed={openFilterExtends}
              placeholder="Pesquise por nome do usuário ou e-mail"
              onChange={handleInputChange}
              value={inputValue}
              onKeyDown={handleInputKeyDown}
              cancelFilterExtendsOpen={cancelFilterExtendsOpen}
              IconFilter={MdFilterList}
              IconSearch={MdSearch}
            >
              <WrapperFlex marginTop={8} justifyStart alignStart row>
                <FilterExtendsUsuarios
                  isOpen
                  isGetModalidadesSuccess={success}
                  setInputValue={setInputValue}
                />
              </WrapperFlex>
            </SearchBox>
          </WrapperFlex>
        </Form>
        <WrapperFlex marginTop={25} justifyStart alignStart row>
          <TabTableUsuarios
            setPaginationParams={setPaginationParams}
            paginationParams={paginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
            handleAcaoUsuarioById={handleAcaoUsuarioById}
            handleAcaoUsuarios={handleAcaoUsuarios}
            handleConfirmAction={handleConfirmAction}
            handleChangeTab={handleChangeTab}
            handleChangePage={handleChangePage}
          />
        </WrapperFlex>
        <ModalNovoUsuario
          onClick={handleModalNovoUsuario}
          isOpen={openModalNovoUsuario}
        />
        <Modal
          tipo="warning"
          onClick={() => {
            handleModalCancelAction();
          }}
          isOpen={openModalCancelAction.warning}
          footer={
            <ModalCancelActionFooter
              onClick={() => {
                handleModalCancelAction();
              }}
              onClickOk={setAcaoUsuario}
            />
          }
        >
          <Text
            center
            text={openModalCancelAction.message}
            font="300 14px work_sans"
            color={theme.titleGray}
          />
        </Modal>
        <Modal
          tipo="success"
          onClick={handleModalUsuarioAcao}
          isOpen={openModalAcaoUsuario.success}
          footer={
            <>
              <Button
                tipo="primary"
                marginBottom={30}
                display="block"
                width={100}
                font="16px unimed_slabregular"
                onClick={handleModalUsuarioAcao}
              >
                ok
              </Button>
            </>
          }
        >
          <Text
            center
            text={openModalAcaoUsuario.message}
            font="300 14px work_sans"
            color={theme.titleGray}
          />
        </Modal>
        <Modal
          tipo="error"
          onClick={handleModalError}
          isOpen={openModalError.error}
          footer={
            <>
              <Button
                tipo="primary"
                marginBottom={30}
                display="block"
                background="#ED1651"
                border="#ED1651"
                type="button"
                width={100}
                font="16px unimed_slabregular"
                onClick={handleModalError}
              >
                ok
              </Button>
            </>
          }
        >
          <Text
            center
            text={openModalError.message}
            font="300 14px work_sans"
            color={theme.titleGray}
          />
        </Modal>
      </FadeIn>
    </Container>
  );
}

const ModalCancelActionFooter = ({ onClick, onClickOk }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        font="16px unimed_slabregular"
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={onClickOk}
        marginLeft={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        font="16px unimed_slabregular"
      >
        sim
      </Button>
    </>
  );
};

export default UsuarioGestao;
